const crypto = require('crypto')

module.exports = {
    hash: password => {
        const passwordHash = crypto.createHash('sha1')
            .update(password, 'utf8')
            .digest('hex')
            .toUpperCase()
        const prefix = passwordHash.substr(0, 5)
        const suffix = passwordHash.substr(5)

        return {
            prefix,
            suffix
        }
    }
}